var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"d-flex flex-wrap justify-center text-center"},[_c('div',{class:{
      'mr-10': _vm.$vuetify.breakpoint.smAndUp
      },staticStyle:{"font-weight":"normal"}},[_vm._v(" "+_vm._s(_vm.cursor + 1)+" / "+_vm._s(_vm.nbQuestions)+" ")]),_c('div',{class:{
      'title-small': _vm.$vuetify.breakpoint.smAndDown
    }},[_vm._v(" "+_vm._s(_vm.one.question)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }